import React from 'react';
import { useQueryRules } from 'react-instantsearch-hooks-web';

const SearchPromoBobbyBerk = () => {
	const { items } = useQueryRules();

	const promos = items.filter(({promo_type, id}) => promo_type === 'designer_collections' && id == 'bobby-berk');

	if (promos.length === 0) {
		return null;
	}

	const promo = promos[0];

	return (
		<div>
			<div className="tw-animate-fade-in tw-bg-aloe tw-px-6 tw-py-5 tw-mb-8">
				<div className='tw-grid md:tw-grid-cols-2 tw-gap-6'>
					<div className="tw-relative">
						<div className="tw-w-full sm:tw-w-[80%] tw-h-[80%] " >
							<img src={promo.images.main.url} alt={promo.images.main.alt} />
						</div>
						<div className="tw-hidden sm:tw-block tw-absolute tw-bottom-0 tw-right-0 tw-w-[200px]">
							<img src={promo.images.sub.url} alt={promo.images.sub.alt} />
						</div>
					</div>
					<div className="-tw-mt-[18%] sm:tw-mt-0 tw-space-y-1 tw-self-center">
						<span className="tw-text-xxxs tw-tracking-wider tw-font-medium tw-uppercase tw-text-charcoal">Designer Collections</span>
						<h2 className="tw-text-charcoal tw-text-2xl">{promo.heading}</h2>
						<div>
							<p className="tw-text-charcoal tw-text-base tw-mt-2 tw-font-medium">
							{promo.description}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default SearchPromoBobbyBerk;
